import { gql } from "graphql-request";

export const PURCHASE_EXPORT = gql`
  query PurchaseExport($input: ExportGenerateInput) {
    GenerateExport(input: $input)
  }
`;
